import React, { FC } from 'react';

import { IFilterDefinition, OptionType } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';

import { BaseFilters } from '../../../components/base-filters/BaseFilters';

import './IssuesFilters.scss';

interface IssuesFiltersProps {
	filters: IFilterOptions;
	onFilterChange: (filters: IFilterOptions) => void;
	isLoading?: boolean;
	filterDefinitions?: IFilterDefinition[];
	filterOptions?: Record<string, OptionType[]>;
}

export const IssuesFilters: FC<IssuesFiltersProps> = ({
	filters,
	onFilterChange,
	isLoading = false,
	filterDefinitions,
	filterOptions
}) => {
	return (
		<BaseFilters
			filters={filters}
			onFilterChange={onFilterChange}
			isLoading={isLoading}
			filterDefinitions={filterDefinitions}
			filterOptions={filterOptions}
			ariaLabel="Issues filters"
			skipLinkId="issues-filters-section"
			className="issues-filters"
			hasTextFilter
			forceRemountOnFilterChange
		/>
	);
};
